import { IProduct } from '@/models/products.model';

export function productPrimaryImageUrl(product: IProduct): string | undefined {
  const fromPhotos = product.photos?.[0]?.preview_url || product.photos?.[0]?.original_url;
  if (fromPhotos) return fromPhotos;
  if (product.photo) return product.photo;
  return undefined;
}
